module.exports = __webpack_public_path__ + "img/blackjack.5654fc3a.png";